import { handleDynamicCalltracking, EPlatformTypes, EPageTypes } from '@cian/frontend-newbuilding-call-component';
import { useCallback, useContext } from 'react';
import { ApplicationContext } from '../../../utils';

type UseDynamicCalltrackingParams = {
  onClick(): void;
  phone: string;
  placeType: string;
  siteBlockId?: number | null;
};

export const useDynamicCalltracking = (params: UseDynamicCalltrackingParams) => {
  const { onClick, phone, placeType, siteBlockId } = params;
  const { logger, httpApi } = useContext(ApplicationContext);

  return useCallback(async () => {
    let dynamicPhone = null;

    if (siteBlockId) {
      const response = await handleDynamicCalltracking({
        logger,
        httpApi,
        blockId: siteBlockId,
        platformType: EPlatformTypes.WebMobile,
        pageType: EPageTypes.NewbuildingCard,
        placeType,
      });

      dynamicPhone = response.notFormattedPhone ? `+${response.notFormattedPhone}` : response.notFormattedPhone;
    }

    if (onClick) {
      onClick();
    }

    const tel = dynamicPhone || phone;
    window.location.href = `tel:${tel}`;
  }, [siteBlockId, logger, httpApi, placeType, onClick, phone]);
};
